import ReactECharts from "echarts-for-react";

export default ReactECharts;
